import { useMemo } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

const createCaptchaService = (executeRecaptcha) => {
  const execute = async (action) => {
    if (!action || typeof action !== 'string') {
      throw new Error('A reCAPTCHA action is required.')
    }

    if (typeof executeRecaptcha !== 'function') {
      throw new Error('reCAPTCHA is not ready. Please try again.')
    }

    try {
      const token = await executeRecaptcha(action)

      if (!token) {
        throw new Error('reCAPTCHA did not return a token.')
      }

      return token
    } catch (error) {
      throw new Error(error?.message || 'reCAPTCHA verification could not be completed.')
    }
  }

  return Object.freeze({ execute })
}

export const useCaptchaService = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  return useMemo(() => createCaptchaService(executeRecaptcha), [executeRecaptcha])
}

export default createCaptchaService
